import React, {useEffect, useRef} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import HiddenInput from 'components/Form/HiddenInput';
import Input from 'components/Form/Input';

export default function MaintenanceItemTemplateForm({
    dirty, isValid, isSubmitting, handleSubmit,
    isCalendarTime, isOperationTime, isDraft, isEditable, isLoading, onCloseClick,
}) {
    const isMounted = useRef(false);
    const isDisabled = !isEditable || !isDraft || isLoading;

    useEffect(() => {
        isMounted.current = true;
        return () => isMounted.current = false;
    }, []);

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Input label="Name" type="text" name="name" required disabled={isDisabled} />
            </Row>
            {isCalendarTime &&
                <>
                    <Row>
                        <Form.Group as={Col} size="lg" style={{marginBottom: 0}}>
                            <Form.Label style={{marginBottom: 0}}>Labels for calendar time in operation (days)</Form.Label>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Input label="Calendar time left (days)" type="text" name="calendar_time_left" required disabled={isDisabled} />
                        <Input label="Calendar time in operation (days)" type="text" name="calendar_time_in_operation" required disabled={isDisabled} />
                        <Input label="Recommended service interval (days)" type="text" name="calendar_service_interval" required disabled={isDisabled} />
                    </Row>
                </>}
            {isOperationTime &&
                <>
                    <Row>
                        <Form.Group as={Col} size="lg" style={{marginBottom: 0}}>
                            <Form.Label style={{marginBottom: 0}}>Labels for operation time (hours)</Form.Label>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Input label="Operation time left (hours)" type="text" name="operation_time_left" required disabled={isDisabled} />
                        <Input label="Time in operation (hours)" type="text" name="operation_time_in_operation" required disabled={isDisabled} />
                        <Input label="Recommended service interval (hours)" type="text" name="operation_service_interval" required disabled={isDisabled} />
                    </Row>
                </>}
            <HiddenInput name="id" />
            {isEditable && isDraft &&
                <Button type="submit" className="btn-form-submit" disabled={!dirty || !isValid || isSubmitting || isDisabled}>Save</Button>}
            <Button type="button" className="btn-form-close" onClick={onCloseClick} disabled={isSubmitting}>Close</Button>
        </Form>
    )
};
